import { api } from "../services/index"

export function getPolicies(appID) {
  return api.get(`/apps/${appID}/policies`)
}

export function getPoliciesOfContract() {
  return api.get(`/policies`)
}

export function addPolicy(appID, data) {
  return api.post(`/apps/${appID}/policies`, data)
}

export function updateAppPolicies(appID, data) {
  return api.post(`/apps/${appID}/policies/sync`, data)
}

export function getPolicy(appID, policyID) {
  return api.get(`/apps/${appID}/policies/${policyID}`)
}

export function patchPolicy(appID, policyID, data) {
  return api.patch(`/apps/${appID}/policies/${policyID}`, data)
}

export function deletePolicy(appID, policyID) {
  return api.delete(`/apps/${appID}/policies/${policyID}`)
}
